var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F6EFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 28.0001H28M12 28.0001V24.0001L20 16.0001M12 28.0001L16 28.0001L24 20.0001M20 16.0001L22.8686 13.1315L22.8704 13.1298C23.2652 12.7349 23.463 12.5371 23.691 12.463C23.8919 12.3977 24.1082 12.3977 24.3091 12.463C24.5369 12.537 24.7345 12.7346 25.1288 13.1289L26.8686 14.8687C27.2646 15.2647 27.4627 15.4628 27.5369 15.6912C27.6022 15.892 27.6021 16.1084 27.5369 16.3092C27.4628 16.5374 27.265 16.7352 26.8695 17.1306L26.8686 17.1315L24 20.0001M20 16.0001L24 20.0001",
    stroke: "#464646",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReportIcon);
export default __webpack_public_path__ + "static/media/edit-report-icon.29891d90c69444db389ae51886337e29.svg";
export { ForwardRef as ReactComponent };